const config = {
  production: true,
  development: false,

  api: 'https://api.partner.bahnkick.com/lessor/ql',

  publicApiRoot: 'https://bahnkick-api.azurewebsites.net/api',

  LOG_ROCKET_KEY: '8kox0k/bahnkick-lessor',

  signalRHubUrl: 'https://bahnkick-signalr.azurewebsites.net/api',

  whatsnewUrl: 'https://fleet.bahnkick.com/whatsnew',
};

export default config;
